import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-home-cards',
  templateUrl: './home-cards.component.html',
  styleUrls: ['./home-cards.component.scss']
})
export class HomeCardsComponent implements OnInit {
  constructor(public dialog: MatDialog) {}

  _mHomeCards = [

    {
      title: 'Availability',
      metric: '99.99%',
      iconClass: '',
      iconColor: 'green',
      detail: 'Uptime',
      // detail: '100% automated API generation, validation, deployment, access and gateway management, logging and monitoring. No more longer development cycles',
      image: '/assets/svg/home-1.svg'
      // image: '/assets/svg/availability.svg'
    },
    {
      title: 'Quality',
      metric: '0.25%',
      iconClass: '',
      iconColor: 'green',
      detail: 'Server Error Rate',
      // detail: '100% automated API generation, validation, deployment, access and gateway management, logging and monitoring. No more longer development cycles',
      image: '/assets/svg/home-1.svg'
      // image: '/assets/svg/quality-assurance.svg'
    },
    {
      title: 'Reliability',
      metric: '99.9%',
      iconClass: '',
      iconColor: 'green',
      detail: 'Effective Pass Rate',
      // detail: '100% automated API generation, validation, deployment, access and gateway management, logging and monitoring. No more longer development cycles',
      image: '/assets/svg/home-1.svg'
      // image: '/assets/svg/reliability.svg'
    },
    {
      title: 'Performance',
      metric: '300ms',
      iconClass: '',
      iconColor: 'green',
      detail: 'Total API Call Latency',
      // detail: '100% automated API generation, validation, deployment, access and gateway management, logging and monitoring. No more longer development cycles',
      image: '/assets/svg/home-1.svg'
      // image: '/assets/svg/speed.svg'
    },
    {
      title: 'Scalability',
      metric: '2000',
      iconClass: '',
      iconColor: 'green',
      detail: 'Transactions per second\n' +
          '(Configurable)\n',
      // detail: '100% automated API generation, validation, deployment, access and gateway management, logging and monitoring. No more longer development cycles',
      image: '/assets/svg/home-1.svg'
      // image: '/assets/svg/vertical-scalability.svg'
    }
    // ,
    // {
    //   title: 'Highly Configurable',
    //   metric: '250x',
    //   iconColor: 'red',
    //   iconClass: 'fa fa-arrow-down',
    //   detail: 'Reduction in Cost',
    //   // detail: 'Configure tools, databases, security & access management and API development lifecycle using declarative user experience.',
    //   image: '/assets/svg/home-1.svg'
    // },
    // {
    //   title: 'High Sustainability',
    //   metric: '0',
    //   iconClass: '',
    //   detail:
    //     'Maintenance Cost',
    //   image: '/assets/svg/home-3.svg'
    // }
  ];

  _mHomeCardsBusiness = [
    {
      title: 'Fully Automated',
      metric: '2400x',
      iconColor: 'green',
      iconClass: 'fa fa-arrow-up',
      detail: 'Improved Productivity',
      // detail: 'Configure tools, databases, security & access management and API development lifecycle using declarative user experience.',
      image: '/assets/svg/home-2.svg'
    },
    {
      title: 'Highly Configurable',
      metric: '250x',
      iconColor: 'red',
      iconClass: 'fa fa-arrow-down',
      detail: 'Reduction in Cost',
      // detail: 'Configure tools, databases, security & access management and API development lifecycle using declarative user experience.',
      image: '/assets/svg/home-1.svg'
    },
    {
      title: 'Developer Experience',
      metric: '1 minute',
      iconColor: 'green',
      iconClass: '',
      detail: 'Design to Public Access',
      // detail: 'Configure tools, databases, security & access management and API development lifecycle using declarative user experience.',
      image: '/assets/svg/home-3.svg'
    }
    // ,
    // {
    //   title: 'High Sustainability',
    //   metric: '0',
    //   iconClass: '',
    //   detail:
    //     'Maintenance Cost',
    //   image: '/assets/svg/home-3.svg'
    // }
  ];


  ngOnInit() {}

  openTooGoodToBelieveDialog(){
    const data = {};
    data['title'] = 'How much does it cost to build an API ?';
    data['description'] = '';
    const dialogRef = this.dialog.open(TooGoodToBelieveComponent, {
      width: '60%',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      // this.accept = result;
    });
  }
}
@Component({
  selector: 'too-good-to-believe-dialog',
  templateUrl: 'toogoodtobelieve.component.html',
  styleUrls: ['toogoodtobelieve.component.scss']
})
export class TooGoodToBelieveComponent {
  constructor(
      public dialogRef: MatDialogRef<TooGoodToBelieveComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) {
  }
}
